<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_880_3092)">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M7 3H19C19.552 3 20 3.448 20 4V20C20 20.552 19.552 21 19 21H7C5.346 21 4 19.654 4 18V6C4 4.346 5.346 3 7 3ZM7 5H18V15H7C6.647 15 6.314 15.072 6 15.184V6C6 5.449 6.449 5 7 5ZM7 19C6.449 19 6 18.551 6 18C6 17.449 6.449 17 7 17H18V19H7Z" fill="currentColor"/>
	</g>
	<defs>
	<clipPath id="clip0_880_3092">
	<rect width="24" height="24" fill="white"/>
	</clipPath>
	</defs>
	</svg>
	